<script>
import PbInput from '@/components/PbInput.vue'
import WithLoader from '@/components/WithLoader'

export default WithLoader(PbInput, {
  events: ['input', 'keypress'],
  pendingProp: 'loading',
})
</script>
